import React, { Component } from 'react';
import {
    Card,
    Calendar,
    Select,
    Col,
    Row,
    Typography,
} from 'antd';


const { Text } = Typography;

class BookingCalendar extends Component {
    getDisabledDates = currentDate => {
        const day = currentDate.day();

        return [6, 0].includes(day);
    }

    renderHeader = ({ value, type, onChange }) => {
        const start = 0;
        const end = 12;
        const monthOptions = [];

        const current = value.clone();
        const localeData = value.localeData();
        const months = [];

        for (let i = 0; i < 12; i++) {
            current.month(i);

            months.push(localeData.monthsShort(current));
        }

        for (let index = start; index < end; index++) {
            monthOptions.push(
                <Select.Option className="month-item" key={`${index}`}>
                    { months[index] }
                </Select.Option>,
            );
        }

        const month = value.format('MMMM');

        const year = value.year();

        return (
            <div style={{ paddingBottom: 10 }}>
                <Row type="flex" justify="space-between">
                    <Col>
                        <Text strong>
                            { month + ' ' + year }
                        </Text>
                    </Col>
                    <Col>
                        <Select
                            size="small"
                            dropdownMatchSelectWidth={false}
                            value={String(month)}
                            onChange={selectedMonth => {
                                const newValue = value.clone();

                                newValue.month(parseInt(selectedMonth, 10));

                                onChange(newValue);

                                this.props.setActiveMonth(newValue);
                            }}
                        >
                            { monthOptions }
                        </Select>

                    </Col>
                </Row>
            </div>
        );
    }

    render() {
        return (
            <Card>
                <Calendar
                    fullscreen={false}
                    onPanelChange={this.props.setActiveMonth}
                    onChange={this.props.onChange}
                    disabledDate={this.getDisabledDates}
                    headerRender={this.renderHeader}
                />
            </Card>
        );
    }
}

export default BookingCalendar;
